module.exports = __webpack_public_path__ + "static/media/photo-1-2-m.45590cfb.jpeg";